module.exports = __webpack_public_path__ + "static/media/icon-idea.e66bed34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-idea.svg
// module id = 725
// module chunks = 0